import { render, staticRenderFns } from "./ModalRattachmentMessage.vue?vue&type=template&id=418c48f9"
import script from "./ModalRattachmentMessage.vue?vue&type=script&lang=js"
export * from "./ModalRattachmentMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports